import React, { useEffect, useState } from 'react';

const CompanyLogo = ({ imglink }) => {
  const fallbackLogo = `${process.env.PUBLIC_URL}/jaboylogo.png`;

  const getLogoURL = (rawUrl) => {
    const value = String(rawUrl || '').trim();
    if (!value) return '';

    if (value.includes('drive.google.com')) {
      const existingThumbnail = value.match(/[?&]id=([^&]+)/);
      if (value.includes('/thumbnail') && existingThumbnail?.[1]) {
        return `https://drive.google.com/thumbnail?id=${existingThumbnail[1]}&sz=w1000`;
      }

      const directMatch = value.match(/[?&]id=([^&]+)/);
      if (directMatch?.[1]) {
        return `https://drive.google.com/thumbnail?id=${directMatch[1]}&sz=w1000`;
      }

      const pathMatch = value.match(/\/d\/([^/]+)/);
      if (pathMatch?.[1]) {
        return `https://drive.google.com/thumbnail?id=${pathMatch[1]}&sz=w1000`;
      }
    }

    // Some records store only the Drive file id.
    if (/^[A-Za-z0-9_-]{20,}$/.test(value)) {
      return `https://drive.google.com/thumbnail?id=${value}&sz=w1000`;
    }

    return value;
  };

  const normalizeLogoSrc = (value) => {
    const normalized = getLogoURL(value);
    return normalized || fallbackLogo;
  };

  const [imageUrl, setImageUrl] = useState(normalizeLogoSrc(imglink));
 
  useEffect(() => {
    setImageUrl(normalizeLogoSrc(imglink));
  }, [imglink]);

  return (
    <img
      src={imageUrl}
      alt="Company Logo"
      width="200px"
      height="200px"
      align ="center"
      onError={(e) => {
        e.target.onerror = null;
        if (imageUrl !== fallbackLogo) {
          setImageUrl(fallbackLogo);
        }
      }}
      // style={{ width: "70%", maxWidth: "1000px", backgroundColor: "#FFFFFF" }}
        style={{ cursor: "pointer", borderRadius: "50%" }}
    />
  );
};

export default CompanyLogo;
